
import { HttpClient } from '@angular/common/http';
import { Component, DOCUMENT, ElementRef, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { loadStyle } from '@app/helpers/loadstyle-helper';
import { Language } from "@commonEnums/language";
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { environment } from '@environments/environment';
import { HelpdeskService } from '@services/helpdesk.service';
import { TranslationService } from '@services/translation.service';
import { Subscription, timer } from 'rxjs';
import { SafeHtmlPipe } from '../../pipes/safeHtml';
import { HelpFlyoutService } from '../catalog/catalog-state/help-trigger/help-flyout.service';
@Component({
	selector: 'app-administration-help',
	templateUrl: './administration-help.component.html',
	styleUrls: ['./administration-help.component.scss'],
	imports: [TranslatePipe, SafeHtmlPipe]
})
export class AdministrationHelpComponent implements OnInit, OnChanges, OnDestroy {

	@Input() helpId: string;
	@Input() useNewHelpdeskURL: boolean = false;
	public helpIsVisible = false;
	public closeIsVisible = false;
	public helpIsAvailable = false;
	public helpContent: string

	private helpflyOutSubscription: Subscription;
	private helpflyOutIdSubscription: Subscription;

	constructor(private http: HttpClient,
		private translationService: TranslationService,
		private helpFlyoutService: HelpFlyoutService,
		private helpdeskService: HelpdeskService,
		private elRef: ElementRef,
		@Inject(DOCUMENT) private document: Document
	) { }

	ngOnInit(): void {
		this.translationService.languageChanged.subscribe(() => {
			this.loadHelpContent();
		});
		this.subscribeToHelpFlyoutService()
		loadStyle("/administration-help.css", 'administration-help-style');
	}

	ngOnChanges(changes: SimpleChanges) {
		// Load Help if it is visible

		if (this.helpId) {
			this.helpIsAvailable = true;
			this.loadHelpContent();
		} else {
			this.helpIsAvailable = false;
		}
	}

	private subscribeToHelpFlyoutService() {
		this.helpflyOutSubscription = this.helpFlyoutService.getState()
			.subscribe(isOpen => {
				this.helpIsVisible = isOpen;
			})

		this.helpflyOutIdSubscription = this.helpFlyoutService.getHelpId()
			.subscribe(helpId => {
				this.helpId = helpId;
				this.loadHelpContent();
			})
	}



	public toggleHelpContent() {
		this.helpIsVisible = !this.helpIsVisible;

		this.loadHelpContent();
		if (this.helpIsVisible) {
			const subscription = timer(650).subscribe(() => {
				this.closeIsVisible = true;
				subscription.unsubscribe();
			});
		} else {
			this.closeIsVisible = false;
		}
	}



	private async loadHelpContent() {
		const content = "";
		if (this.helpId) {
			const language = this.translationService.getLanguage();
			let languageString = "de-DE";
			if (language === Language.EN) {
				languageString = "en-EN";
			}

			const useNewHelpdesk = await this.helpdeskService.getUseNewHelpdesk();

			if(useNewHelpdesk){
				const content = await this.helpdeskService.getHelpdeskContent("ADE_VERWALTUNGEN", this.helpId);
				this.helpIsAvailable = true;
				this.helpContent = this.transformHelpResponse(content);

				const timerSubscribe = timer(10).subscribe(() => {
					this.elRef.nativeElement.querySelectorAll('a')?.forEach(element => {
						element.addEventListener('click', this.linkClick.bind(this))
					});
					timerSubscribe.unsubscribe();
				});
			}
			else{
				const url = `${environment.helpdesk}/htmlcontent/${this.helpId}/${languageString}`;

				const helpresponse = this.http.get(url, { headers: { 'x_api_key': environment.helpdeskApiKey }, responseType: 'text' });
				helpresponse.subscribe(
					(response) => {
						if (content.length === 0) {
							this.helpIsAvailable = true;

							this.helpContent = this.transformHelpResponse(response);
							const timerSubscribe = timer(10).subscribe(() => {
								this.elRef.nativeElement.querySelectorAll('a')?.forEach(element => {
									element.addEventListener('click', this.linkClick.bind(this))
								});
								timerSubscribe.unsubscribe();
							});
						} else {
							this.helpIsAvailable = false;
						}

						this.elRef.nativeElement.querySelector('#helpContentScrollArea')?.scrollTo(0, 0);
					},
					(error) => {
						this.helpIsAvailable = false;
						this.helpContent = "";
					}
				);
			}
		}
	}

	private transformHelpResponse(response: string): string {
		const transformedResponse = Array();
		response.split('<a ').forEach((el, index) => {
			if (index > 0) {
				transformedResponse.push(!el.includes('target="_blank"') ? 'onclick = "return false;" ' + el : el)
			} else {
				transformedResponse.push(el)
			}
		});

		return transformedResponse.join('<a ');	
	}

	private linkClick(click) {
		let link = click.srcElement
		while (!(link.tagName === "A") && link.parentNode) {
			link = link.parentNode
		}
		if (!(link.attributes?.target?.value === "_blank")) {
			this.helpId = link.attributes.href.value.split("/").pop();
			this.loadHelpContent();
		}
	}

	ngOnDestroy() {
		this.helpflyOutSubscription?.unsubscribe();
		this.helpflyOutIdSubscription?.unsubscribe();
	}

}
